var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3216 7.30312L15.3217 7.30323C15.4629 7.44364 15.5749 7.61071 15.6511 7.79474C15.7274 7.97878 15.7663 8.17611 15.7656 8.3753V8.37545V15.8754C15.7656 16.1117 15.6718 16.3382 15.5048 16.5052C15.3378 16.6722 15.1112 16.7661 14.875 16.7661H1.12501C0.8888 16.7661 0.662266 16.6722 0.495241 16.5052C0.328216 16.3382 0.234383 16.1117 0.234383 15.8754L0.234383 8.37545L0.234383 8.3753C0.233743 8.17611 0.272659 7.97878 0.348873 7.79474C0.425088 7.61071 0.537083 7.44364 0.678364 7.30323L0.678466 7.30312L6.92846 1.05313C7.21268 0.768994 7.59812 0.609375 8.00001 0.609375C8.4019 0.609375 8.78733 0.768994 9.07155 1.05312L15.3216 7.30312ZM13.9375 14.9848H13.9844V14.9379V8.50435V8.48494L13.9707 8.47121L8.03315 2.53371L8.00001 2.50056L7.96686 2.53371L2.02936 8.47121L2.01563 8.48494V8.50435V14.9379V14.9848H2.06251H13.9375Z",
    fill: "#393939",
    stroke: "#393939",
    strokeWidth: 0.09375
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.7c7b3c01dcf5da28c7cf5c4289356fd4.svg";
export { ForwardRef as ReactComponent };